import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";


class CMVEntradasDB extends FirestorePipe {
    public static readonly colName = 'Entradas'

    constructor(idEstab: string, idStore: string, prodId: string) {
        if (!idEstab)
            throw new Error('Informe o id do estabelecimento')
        if (!idStore)
            throw new Error('Informe o id da Loja')
        if (!prodId)
            throw new Error('Informe o id do produto')
        super(`${EstablishmentDB.colName}/${idEstab}/Stores/${idStore}/Cmv/${prodId}/Entradas`);
    }

    getAll(...params: QueryConstraint[]): Promise<any[]> {
        return this._getAll<any>(...params);
    }
    get(id: string): Promise<any> {
        throw new Error("Method not implemented.");
    }
    public on(listener: (data: any[]) => void, ...params: QueryConstraint[]): Unsubscribe {
        return this._on(listener, ...params);
    }
    create(data: any): Promise<any> {
        return this._create(data)
    }
    update(id: string, data: any): Promise<any> {
        throw new Error("Method not implemented.");
    }
    delete(id: string): Promise<any> {
        throw new Error("Method not implemented.");
    }

}

export default CMVEntradasDB;